import React from 'react';
import { Link } from 'react-router-dom';
const parser = new DOMParser();

const StyledText = React.forwardRef(
  function StyledText({value, format, ...props}, ref) {
    const nodes = React.useMemo(() => {
      if (value.indexOf('<') === -1) {
        return [value];
      }

      const dom = parser.parseFromString(
        `<template>${value}</template>`,
        'text/xml',
      );

      const visitNode = (node) => {
        const {tagName, textContent} = node;
        if (!tagName) return textContent || '';

        const attrs = Object.fromEntries(
          Array.from(node.attributes)
          .map(({name, value}) => [name, value])
        );

        const nodes = Array.from(node.childNodes).map(visitNode);
        if (tagName === 'Link') {
          return React.createElement(Link, attrs, ref, ...nodes);
        }
        else {
          const formatter = format[tagName];
          const {tag, ...props} = formatter(attrs, nodes);
          return React.createElement(tag || 'span', props, ...nodes);
        }
      };

      return Array.from(dom.firstChild.childNodes).map(visitNode);
    }, [value, format]);

    return React.createElement('span', {...props, ref}, ...nodes);
  }
);

StyledText.displayName = 'StyledText';

export {
  StyledText,
};



// WEBPACK FOOTER //
// ./src/StyledText.js